// extracted by mini-css-extract-plugin
export default {"root":"LLPACard_root__QXMLD","actions":"LLPACard_actions__P497C"};